"use client";

import React from "react";

import type { LookedUpTenant } from "./applyTenantContentColours";

const TenantContext = React.createContext<{
	tenant: LookedUpTenant;
} | null>(null);

export function useTenantContext() {
	const context = React.useContext(TenantContext);

	if (!context) {
		throw new Error("useTenantContext must be used within a TenantProvider");
	}

	return context;
}

export function useActiveTenant(): LookedUpTenant {
	const { tenant } = useTenantContext();

	return tenant;
}

export default function TenantProvider({
	children,
	tenant,
}: {
	children: React.ReactNode;
	tenant: LookedUpTenant;
}) {
	const value = React.useMemo(
		() => ({
			tenant,
		}),
		[tenant],
	);

	return (
		<TenantContext.Provider value={value}>{children}</TenantContext.Provider>
	);
}
